import api, { request } from '../../../api';
import { IActionGroup, IStore } from '../../index';
import { ICourse } from './store';

import { IErrorsStore } from '../../errors/store';

export interface IAdminCoursesActions extends IActionGroup {
  all: () => { events?: ICourse[]; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  all: async (state: IStore) => {
    if (state.adminCourses.length) {
      return state;
    }

    const response = await request.get(`${api.admin.courses()}`);

    if (response.error) {
      return { errors: { courses: { msg: 'Error Retrieving courses list.' } } };
    }

    return {
      adminCourses: response
    };
  }
};

export default actions;
